import React from 'react'
import { Routes, Route } from 'react-router-dom';

import Details from './Details';

function EmployeeRecord() {

  return (
    <>
      <Routes>
        <Route path="details/:id" element={<Details />} />
      </Routes>
    </>
  );
}

export default EmployeeRecord;